import React from 'react';
import { IntegrationProps } from '../types';

export const AiSensySettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">API Key</label>
        <input
          type="password"
          value={config.apiKey || ''}
          onChange={(e) => onChange({ apiKey: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
    </div>
  );
};